import { createSvgIcon } from '@mui/material';

export const ExchangeIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
    <path
      fill="currentColor"
      d="M15.834 16.207c-1.579 1.58-3.505 2.34-5.777 2.284-2.272-.057-4.379-1.055-6.057-2.733l.029.028-1.165 1.307a.5.5 0 0 1-.873-.318l-.123-4.048a.5.5 0 0 1 .515-.515l4.024.122a.5.5 0 0 1 .312.877l-1.305 1.132c1.253 1.253 2.864 2.033 4.571 2.079 1.708.045 3.156-.527 4.347-1.717.306-.307.569-.645.788-1.015.22-.37.396-.77.529-1.204l2.187.066a7.993 7.993 0 0 1-.759 2 7.274 7.274 0 0 1-1.243 1.655Zm1.875-8.47a.5.5 0 0 1-.515.516L13.17 8.13a.5.5 0 0 1-.313-.878l1.306-1.132C12.91 4.87 11.299 4.088 9.592 4.043c-1.708-.046-3.156.526-4.347 1.717a5.14 5.14 0 0 0-.789 1.014c-.219.37-.395.771-.528 1.204l-2.187-.066c.172-.723.425-1.39.759-1.999a7.272 7.272 0 0 1 1.243-1.656c1.579-1.579 3.505-2.34 5.777-2.284 2.272.057 4.379 1.056 6.057 2.734l1.132-1.305a.5.5 0 0 1 .878.312l.122 4.024Z"
    />
  </svg>,
  'ExchangeIcon',
);
